import request from "@/util/axios";

// 共享变量
var _Qipiao_order_tmp_ = {};

const Qipiao_get_order = function (qipiao_order_id, qipiao_order_type) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("qipiao_order_id", qipiao_order_id);
    formData.append("qipiao_order_type", qipiao_order_type);

    // 查询待支付订单信息 主要是金额
    request.post("/mall/qipiao-order-fee", formData).then((res) => {
      budo_log.info("#14 qipiao-order-fee, res=", res);

      if (res && res.data) {
        _Qipiao_order_tmp_ = {};
        _Qipiao_order_tmp_.tradeno = qipiao_order_id
        _Qipiao_order_tmp_.orderFee = Number(res.data.totalUserPrice) * 100;

        resolve(_Qipiao_order_tmp_);
        return;
      }

      reject("Qipiao-order-fee err");
    });
  });
};

const Qipiao_order_info_for_pay = function (cards, _goodsType) {
  budo_log.info("#30 _Qipiao_order_tmp_=", _Qipiao_order_tmp_, "cards=", cards);

  _Qipiao_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _Qipiao_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _Qipiao_order_tmp_.goodsList = [];

  _Qipiao_order_tmp_.orderType = _goodsType;
  _Qipiao_order_tmp_.goodsType = _goodsType;
  _Qipiao_order_tmp_.expressFee = 0;
  _Qipiao_order_tmp_.wxPayFee = 0;

  _Qipiao_order_tmp_.cardMoney = _Qipiao_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);
  _Qipiao_order_tmp_.wxPayFee = _Qipiao_order_tmp_.orderFee - _Qipiao_order_tmp_.cardMoney;

  return _Qipiao_order_tmp_;
};

export { Qipiao_get_order, Qipiao_order_info_for_pay };
